<template>
  <div class="v2-add-nickname">
    <div
      v-if="hasNickName"
      class="v2-add-nickname__display"
    >
      <span>{{ data.item.retailerBrandIdentity }}</span>
      <button
        class="v2-add-nickname__edit-btn"
        @click="showModal = true"
      >
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
        </svg>
      </button>
    </div>
    <button
      v-else
      class="v2-add-nickname__add-btn"
      @click="showModal = true"
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
      </svg>
    </button>

    <v2-modal
      :show="showModal"
      :title="hasNickName ? 'Update nickname' : 'Enter nickname'"
      size="sm"
      @close="onClickCancel"
    >
      <form @submit.prevent="onSubmitNickName">
        <v2-input
          v-model="nickName"
          label="Nickname"
          placeholder="Nickname"
          :error="nickNameError"
        />
        <div class="v2-flex v2-justify-end v2-gap-2 v2-mt-4">
          <v2-button
            variant="outline"
            @click="onClickCancel"
          >
            Cancel
          </v2-button>
          <v2-button
            type="submit"
            :disabled="!nickName || nickName.length < 3 || saving"
            :loading="saving"
          >
            {{ saving ? 'Saving' : 'Save' }}
          </v2-button>
        </div>
      </form>
    </v2-modal>
  </div>
</template>

<script>
import V2Modal from '@/components/v2/V2Modal.vue'
import V2Input from '@/components/v2/V2Input.vue'
import V2Button from '@/components/v2/V2Button.vue'
import { useNickName } from '@/composables/useNickName'

export default {
  name: 'V2AddNickName',
  components: {
    V2Modal,
    V2Input,
    V2Button,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  setup() {
    return { ...useNickName() }
  },
  data() {
    return {
      showModal: false,
    }
  },
  computed: {
    hasNickName() {
      return !!this.data?.item?.retailerBrandIdentity
    },
  },
  watch: {
    'data.item.retailerBrandIdentity': {
      handler(val) {
        this.initNickName(val)
      },
      immediate: true,
    },
  },
  methods: {
    onClickCancel() {
      this.showModal = false
      this.initNickName(this.data?.item?.retailerBrandIdentity)
    },
    async onSubmitNickName() {
      const { success } = await this.submitNickName(
        this.data.item.retailerId,
        this.hasNickName,
      )
      if (success) {
        this.showModal = false
        this.$emit('load-connections')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.v2-add-nickname {
  &__display {
    display: flex;
    align-items: center;
    gap: var(--v2-space-2);
  }

  &__edit-btn,
  &__add-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: var(--v2-space-1);
    background: transparent;
    border: none;
    border-radius: var(--v2-radius-sm);
    color: var(--v2-muted-foreground);
    cursor: pointer;
    transition: all 0.15s ease;

    &:hover {
      background: var(--v2-muted);
      color: var(--v2-primary);
    }
  }
}
</style>
